import styles from './email-manager.module.scss'
import React, { useState, useEffect, useRef } from 'react'

//antd
import { Input, Row, Col, notification, Table, Button, Popconfirm } from 'antd'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//components
import { compare } from 'utils'
import EmailManagerForm from './email-manager-form'

//apis
import { getEmailManager, deleteEmailManagerer } from 'apis/emailManager'
import FilterRegion from 'components/filter-region'

export default function EmailManager() {
  const typingTimeoutRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [emailManagerData, setEmailManagerData] = useState([])
  const [countEmailManager, setCountEmailManager] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({
    ...JSON.parse(localStorage.getItem('emailManagerFilter'))?.paramsFilter,
    page: 1,
    page_size: 20,
  })
  const [valueSearch, setValueSearch] = useState(
    JSON.parse(localStorage.getItem('emailManagerFilter'))?.paramsFilter?.email
  )

  const onSearch = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value
      if (value) paramsFilter.email = value
      else delete paramsFilter.email

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 750)
  }

  const _getEmailManager = async () => {
    try {
      setLoading(true)
      const res = await getEmailManager({ ...paramsFilter })
      console.log(res)
      if (res.status === 200) {
        setEmailManagerData(res.data.data)
        setCountEmailManager(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _deleteEmailManagerer = async (id) => {
    try {
      setLoading(true)
      const res = await deleteEmailManagerer(id)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xoá email thành công!' })
          _getEmailManager({ ...paramsFilter })
        } else
          notification.error({
            message: res.data.message || 'Xoá email thất bại, vui lòng thử lại!',
          })
      } else
        notification.error({
          message: res.data.message || 'Xoá email thất bại, vui lòng thử lại!',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }
  const columns = [
    // {
    //   title: 'Quản lý viên',
    //   render: (text, record) => record.name,
    //   sorter: (a, b) => compare(a, b, 'code'),
    // },
    // {
    //   title: 'Liên hệ',
    //   dataIndex: 'phone',
    // },
    {
      title: 'Email',
      width: 300,
      render: (text, record) => (
        <EmailManagerForm infoEmail={record} reloadData={_getEmailManager}>
          <a>{record.email}</a>
        </EmailManagerForm>
      ),
    },
    {
      title: 'Quốc gia',
      render: (text, record) => record?.country_infos?.map(country => {
        return <div>{country.name}</div>
      }),
    },
    {
      title: 'Khu vực',
      render: (text, record) => record?.region_infos?.map(region => {
        return <div>{region.name}</div>
      }),
      //   sorter: (a, b) => compare(a, b, 'phone'),
    },
    {
      title: 'Chi nhánh',
      render: (text, record) => record?.branch_infos?.map(branch =>{
        return <div>{branch.name}</div>
      }),
    },
    {
      title: 'Hành động',
      width: 100,
      render: (text, record) => (
        <Popconfirm
          onConfirm={() => _deleteEmailManagerer(record._id)}
          title="Bạn có muốn xóa email này không?"
        >
          <Button icon={<DeleteOutlined />} type="primary" danger />
        </Popconfirm>
      ),
    },
  ]

  const onClickClear = async () => {
    setParamsFilter({ page: 1, page_size: 20 })
    setValueSearch('')
  }

  useEffect(() => {
    _getEmailManager()
  }, [paramsFilter])

  return (
    <div className={`${styles['email_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Cài đặt email quản lý</div>
        <EmailManagerForm reloadData={_getEmailManager}>
          <Button size="large" type="primary" icon={<PlusCircleOutlined />}>
            Thêm email
          </Button>
        </EmailManagerForm>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={11} lg={11} xl={9}>
          <Input
            size="large"
            style={{ width: '100%' }}
            name="email"
            value={valueSearch}
            enterButton
            onChange={onSearch}
            placeholder="Tìm kiếm theo email"
            allowClear
          />
        </Col>
        <Col xs={24} sm={24} md={11} lg={11} xl={9}>
          <FilterRegion
            width_size="100%"
            setParamsFilter={setParamsFilter}
            paramsFilter={paramsFilter}
          />
        </Col>
        <Col xs={24} sm={24} md={11} lg={11} xl={6}>
          <Button
            onClick={onClickClear}
            style={{ display: Object.keys(paramsFilter).length < 3 && 'none' }}
            type="primary"
            size="large"
            danger
          >
            Xóa tất cả lọc
          </Button>
        </Col>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        loading={loading}
        columns={columns}
        dataSource={emailManagerData}
        style={{ width: '100%', marginTop: 20 }}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: [20, 30, 40, 50, 70, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countEmailManager,
        }}
      />
    </div>
  )
}
